import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminStereoVideosRoutes } from 'lib_ts/enums/routing/routes/admin-stereo-videos';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { IStereoVideo } from 'lib_ts/interfaces/i-stereo-video';
import { BaseRESTService } from 'services/_base-rest.service';

export class StereoVideosService extends BaseRESTService {
  private static instance: StereoVideosService;
  static getInstance(): StereoVideosService {
    if (!StereoVideosService.instance) {
      StereoVideosService.instance = new StereoVideosService();
    }

    return StereoVideosService.instance;
  }

  private constructor() {
    super({
      controller: Controller.StereoVideos,
    });
  }

  async getOne(id: string): Promise<IStereoVideo | undefined> {
    return await this.get({
      uri: `${AdminStereoVideosRoutes.GetOne}/${id}`,
    })
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return;
        }

        return res.data;
      })
      .catch((err) => {
        console.error(err);
        return;
      });
  }

  async getMany(videoIDs: string[]): Promise<IStereoVideo[]> {
    return await this.post(
      {
        uri: AdminStereoVideosRoutes.GetMany,
      },
      videoIDs
    )
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return;
        }

        return res.data;
      })
      .catch((err) => {
        console.error(err);
        return;
      });
  }
}
